import React from "react";

import { IIconType } from "components/shared/icon_types/_prop_interface";

function Checkmark({ size, color, ...rest }: IIconType) {
  return (
    <svg
      className="checkmark"
      viewBox="0 0 11 10"
      height={size}
      width={size}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="toggle"
          transform="translate(-2.000000, -2.000000)"
          strokeWidth="2"
          stroke={color}>
          <g id="Group-5">
            <polyline
              id="Path-3"
              points="3 6.0309002 6.08999042 9.12196661 11.71 3.5"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Checkmark;
